import { render, staticRenderFns } from "./MaterializecssModal.vue?vue&type=template&id=47728cd6&scoped=true"
import script from "./MaterializecssModal.vue?vue&type=script&lang=js"
export * from "./MaterializecssModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47728cd6",
  null
  
)

export default component.exports